// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Slider from 'components/slider/slider'

class HappyTail extends React.Component {
	handleAccordionTitleClick = ( e ) => {
		const section = e.currentTarget.parentNode
		const content = section.querySelector( '.accordion-content' )
		const height = section.getAttribute( 'data-height' )

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
			content.style.maxHeight = `${height}px`
		} else {
			section.classList.remove( 'is-active' )
			section.classList.add( 'is-not-active' )
			content.style.maxHeight = '0'
		}
	}

	render() {
		const { title, imageUrl, content, imageGallery } = this.props

		if ( ! title || ! imageUrl || ! content ) {
			return null
		}

		return (
			<div className="person person-accordion">
				<div className="-inner accordion-section is-not-active">
					<header className="accordion-title-b" onClick={ this.handleAccordionTitleClick }>
						<div className='-img'>
							<img src={ imageUrl } alt={ title } />
						</div>

						<div className='-title'>
							<h3 dangerouslySetInnerHTML={ { __html: title } } />
						</div>

						<i></i>
					</header>

					<main className="accordion-content">
						<div className="-text" dangerouslySetInnerHTML={ { __html: content } } />
					</main>
				</div>
			</div>
		)
	}
}

export default HappyTail



// WEBPACK FOOTER //
// ./views/main/page/HappyTail.jsx